export function bviInit() {
    new isvek.Bvi({
        target: '.bvi-open', // ID кнопки активации
        theme: 'white',       // Тема интерфейса: white, black, blue, brown или green
        fontSize: 16,         // Базовый размер шрифта
        letterSpacing: 'normal', // Интервал между буквами
        lineHeight: 'normal', // Интервал между строками
        speech: true,         // Включение голосового сопровождения
        panelHide: false,     // Возможность скрыть панель
        languages: {
            active: 'ru',     // Язык интерфейса: 'ru', 'en' и т. д.
            ru: {             // Русскоязычные строки интерфейса
                panelTitle: 'Настройки для слабовидящих',
                close: 'Закрыть',
                // Другие строки
            }
        }
    });

    $(document).on('click', '.visually-impaired', function () {
        console.log('dfgfdgg')
        if ($('.sidebar-mobile').hasClass('sidebar-mobile__show')) {
            $('.sidebar-mobile').removeClass('sidebar-mobile__show')
        }
    })

    // Целевая функция для изменения цвета фона .burger
    function updateBurgerBackground(theme) {
        const burger = $('.burger');

        // Задаем цвета в зависимости от темы
        switch (theme) {
            case 'white':
                burger.css('background-color', '#000'); // Тёмная тема
                break;
            case 'black':
                burger.css('background-color', '#fff'); // Светлая тема
                break;
            case 'blue':
                burger.css('background-color', '#063462'); // Синяя тема
                break;
            case 'brown':
                burger.css('background-color', '#4d4b43');
                break;
            case 'green':
                burger.css('background-color', '#a9e44d');
                break;
            default:
                burger.css('background-color', ''); // Сброс по умолчанию
        }
    }

    // Настройка MutationObserver
    const observer = new MutationObserver((mutationsList) => {
        let bviBody = $('.bvi-body');

        if (bviBody.length) {
            // Если .bvi-body существует, обновляем фон в зависимости от темы
            const currentTheme = bviBody.attr('data-bvi-theme');
            updateBurgerBackground(currentTheme);
        } else {
            // Если .bvi-body удален, сбрасываем стили
            updateBurgerBackground(null);
        }
    });

    // Наблюдение за изменением атрибутов у bvi-body
    observer.observe(document.body, {
        childList: true, // Следим за добавлением и удалением элементов
        subtree: true,   // Включаем наблюдение за вложенными элементами
        attributes: true, // Следим за изменением атрибутов
        attributeFilter: ['data-bvi-theme'] // Следим только за data-bvi-theme
    });
    const currentTheme = $('.bvi-body').attr('data-bvi-theme');
    updateBurgerBackground(currentTheme)
}


